import {
  MONARCH_SOURCE,
  MONARCH_TOKEN,
  SOURCE_KEY,
  WRITE_KEY,
} from "@/js/constants/cohesion";

export const cohesionSnippet = {
  tagular: {
    apiKey: "e1f374e9-08d8-4f42-a744-ddfdaee997dd",
    writeKey: WRITE_KEY,
    sourceKey: SOURCE_KEY,
    taggy: { enabled: true },
  },
  monarch: {
    sourceId: MONARCH_SOURCE,
    token: MONARCH_TOKEN,
    autoRequest: {
      enabled: true,
      suppressPlacements: true,
      params: {
        writeKey: WRITE_KEY,
        makeSourceUid: SOURCE_KEY,
        sourceId: MONARCH_SOURCE,
        token: MONARCH_TOKEN,
      },
    },
  },
  fuse: {
    leases: [{ pool: "qEk6PrZcJoSyErMUQX2pLj" }],
    metadata: {
      vdn: "68231",
    },
  },
  consent: {
    onetrust: {
      enabled: true,
      optIn: false,
    },
    required: true,
    cookieClassification: "C0002",
  },
  writeKey: WRITE_KEY,
  sourceKey: SOURCE_KEY,
};
